import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import {
  customerTypeOptions,
  currencyCodeOptions,
  defaultOrderTypeOptions,
  countryOptions,
  stateOptions,
  defaultPickingTypeOptions
} from "layouts/views/common/options";
import { useState } from "react";
import { getCompanyList } from "services/data.internal.service";
import { TitleButton } from "ui-components/Form";

import { FormTitle, TitleField, Text, SelectField, SwitchField } from "ui-components/Form";
import CustomerLogo from "./CustomerLogo";

const option = {
  customerType: customerTypeOptions,
  currencyCode: currencyCodeOptions,
  defOrderType: defaultOrderTypeOptions,
  countryOptions,
  stateOptions,
  defPickingType: defaultPickingTypeOptions
};
function CustomerInfo({
  formRender,
  carrierCodeOptions = [],
  control,
  errors,
  getValues,
  setValue,
  mode = "ADD",
}) {
  const [companyOptions, setCompanyOptions] = useState([]);
  useQuery({
    queryKey: [],
    queryFn: () => getCompanyList({ active: true }),
    onSuccess: (data) => setCompanyOptions(data.data.data.map((x) => x.companyCode)),
  });
  const applyBilling = () => {
    const {
      billCompany,
      billAddress1,
      billAddress2,
      billPostcode,
      billCity,
      billState,
      billCountry,
      billPhoneNo,
      billFaxNo,
    } = getValues();
    setValue("shipCompany", billCompany);
    setValue("shipAddress1", billAddress1);
    setValue("shipAddress2", billAddress2);
    setValue("shipPostcode", billPostcode);
    setValue("shipCity", billCity);
    setValue("shipState", billState);
    setValue("shipCountry", billCountry);
    setValue("shipPhoneNo", billPhoneNo);
    setValue("shipFaxNo", billFaxNo);
  };
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Customer Information" : "Customer Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { disabled, editable, size, ...data } = property;
              const xs = size ? size : 12 / rows.length;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(disabled && { disabled }),
                ...(mode === "EDIT" && editable === false && { disabled: true }),
              };
              let renderField;
              switch (data.type) {
                case "text":
                case "number":
                  renderField = <Text field={fieldProps} />;
                  break;
                case "select":
                  let options = [];
                  switch (data.name) {
                    case "companyCode":
                      options = companyOptions;
                      break;
                    case "customerType":
                    case "currencyCode":
                    case "defOrderType":
                      options = option[data.name];
                      break;
                    case "billState":
                    case "shipState":
                      options = option.stateOptions;
                      break;
                    case "billCountry":
                    case "shipCountry":
                      options = option.countryOptions;
                      break;
                    case "preferredCarrier":
                      options = carrierCodeOptions;
                      break;
                    case "defPickingType":
                      options = defaultPickingTypeOptions;
                      break;
                  }
                  renderField = <SelectField field={fieldProps} options={options} />;
                  break;
                case "switch":
                  renderField = <SwitchField field={fieldProps} />;
                  break;
                case "title":
                  renderField = <TitleField label={data.label} />;
                  break;
                case "button":
                  let button = null;
                  button = <TitleButton label="Apply Billing To Shipping" onClick={applyBilling} />;
                  renderField = button;
                  break;
              }

              return (
                <Grid item xs={xs} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
      {mode==="EDIT" && <CustomerLogo type="CompanyLogo"/> }
      {mode==="EDIT" && <CustomerLogo type="DOReportLogo"/> }
       
    </MDBox>
  );
}

export default CustomerInfo;
